import { ForwardedRef, forwardRef } from 'react';
// Local Imports
import {
  AppSettingsIcon,
  CrossIcon,
  NotSuspendUserIcon,
  SuspendUserIcon,
  TickMarkIcon
} from '../../../assets/icons';

interface TableActionsProps {
  children: any;
  placement?: string;
  width?: string;
  height?: string;
  className?: string;
  restProps: { [key: string]: any };
  isActive: boolean;
  onToggle: any;
}

const Status = (status: boolean, activeText: string, inactiveText: string) => {
  return status ? (
    <div className='flex justify-start items-center gap-[5px]'>
      <TickMarkIcon />
      {activeText}
    </div>
  ) : (
    <div className='flex justify-start items-center gap-[5px]'>
      {inactiveText === 'Verified' ? (
        <CrossIcon className='!text-danger' />
      ) : (
        <div className='w-[12px] h-[12px] rounded-full ring-danger ring-2 text-danger'></div>
      )}
      {inactiveText}
    </div>
  );
};
// Account Status
export const accountStatus = (status: boolean, activeText: string, inactiveText: string) => {
  return status ? (
    <div className='flex justify-start items-center gap-[5px]'>
      <SuspendUserIcon className=' w-[20px] h-[20px] fill-danger' />
      {activeText}
    </div>
  ) : (
    <div className='flex justify-start items-center gap-[5px]'>
      <NotSuspendUserIcon className=' w-[20px] h-[20px] fill-success' />
      {inactiveText}
    </div>
  );
};

export const Rating: React.FC<{ row: any }> = ({ row }) => {
  const value = Number(row?.row?.ratings?.rating || 0);
  const max = 5;
  const color = '#FACC15';
  const inactiveColor = '#E5E7EB';
  const size = 16;

  const stars = Array.from({ length: max }, (_, i) => {
    const isFill = i < value;
    return (
      <svg
        width={size}
        height={size}
        viewBox='0 -0.5 32 32'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M16.0005 0L21.4392 9.27275L32.0005 11.5439L24.8005 19.5459L25.889 30.2222L16.0005 25.895L6.11194 30.2222L7.20049 19.5459L0.000488281 11.5439L10.5618 9.27275L16.0005 0Z'
          fill={isFill ? color : inactiveColor}
        />
      </svg>
    );
  });

  return <div className='flex items-center gap-[2px]'>{stars}</div>;
};

// ACTION IN TABLE
export const TableAction = (
  {
    children,
    restProps,
    placement,
    width,
    height,
    className,
    isActive,
    onToggle
  }: TableActionsProps,
  ref: ForwardedRef<any>
) => {
  const index = restProps?.row?.index || restProps?.row?.idx;

  // useOnClickOutside();

  return (
    <div className='cursor-pointer  min-w-max relative'>
      <AppSettingsIcon className='translate-x-3' onClick={() => onToggle(index)} />
      {isActive && (
        <div
          className={`popover p-2 ${
            isActive ? 'open' : ''
          }  bg-white z-50 right-0 rounded-[4px] popover-shadow  ${width ? width : 'w-[200px]'} ${
            height ? height : 'h-[200px]'
          } ${placement ? placement : 'right-6 top-7'} ${className}`}
          ref={ref}
        >
          {children()}
        </div>
      )}
    </div>
  );
};

//ForwardREF to Handle Popover Closing
export const TableActions = forwardRef<any, TableActionsProps>(TableAction);

export default Status;
